export class PatientAdminExportCriteriaDTO {
}